window.dn = window.dn || {};

/** All methods related to our message stream. */
(function (stream, $, undefined)
{
    var currentPage = 0;
    var done = false;
    var isProfilePage = $("#search-user-messages").length > 0;  // detect whether we're on the profile page or homepage

    var numPageLoads = 0;
    var maxPageLoads = 50;  // don't let us call "loadMore" more than this

    dn.CurrentTopicId = 0;
    dn.CurrentTypeId = 0;

    stream.Topics = [];
    stream.MakeSelection = '';          // empty string implies all makes

    stream.TotalDiscussions = 0;
    stream.Vue = {};
    stream.UnreadDiscussionsOnly = false;

    /** Internal stream error codes */
    stream.Error = 
    {
        LoadingItems:   1,
        NoItems:        2,
        RenderingItem:  3,
        SearchPlatformError: 4
    };

    /** Used to store any keywords being searched. */
    stream.Keywords = null;

    /** Used to pass additional options when fetching data */
    stream.Options = {};

    /** Used to cache partner info. */
    stream.Partners = {};

    /** 
     * Retains info about each message currently visible in the current stream (useful for de-duping). 
     * The key is the MessageKey, the value is currently just `true`.
     */
    stream.Messages = {};

    /** See if we're filtering by type. */
    stream.Type = window.location.pathname.substring(1); // at this point it might be more than one directory, but we'll fix it in a sec

    var secondSlash = stream.Type.indexOf("/");
    if (secondSlash == 1)
    {
        // this means there was no type filter, just /t/topic or /g/group
        stream.Type = '';
        stream.Types = [];
    }
    else 
    {
        if (secondSlash > -1)
        {
            stream.Type = stream.Type.substring(0, secondSlash);
        }

        dn.CurrentTypeId = dn.constants.DiscussionTypesByKey[stream.Type];
        stream.Types = (dn.CurrentTypeId && dn.CurrentTypeId != 0) ? [dn.CurrentTypeId] : (Array.isArray(dn.QueryString["ty"]) ? dn.QueryString["ty"] : (dn.QueryString["ty"] ? [dn.QueryString["ty"]] : []));
    }

    /**
     * Initialization code called only from pages that actually need to use it.
     */
    stream.Init = function()
    {
        stream.Vue = new Vue
        (
            {
                el: '#homepage-stream',
                data: 
                {
                    Messages: [],
                    SearchRequest: {},
                    busy: false
                },
                beforeCreate: function() 
                {
                    // Replace our data-v-infinite-scroll attribute with the non-standard Vue plugin attribute, "v-infinite-scroll".
                    // We are only doing this to pass W3C validation. Once custom attributes are acceptable, we can just use it directly.
                    $('div[data-v-infinite-scroll]').each(function(index) 
                    {
                        $(this).attr('v-infinite-scroll', $(this).data('v-infinite-scroll'));
                        $(this).removeAttr('data-v-infinite-scroll');
                    });

                    // Add in vue v-bind directives that W3C normally complains about, due to the colon not being XML compliant for attributes
                    $('message-line-item').attr(":message", "item").attr(":vue-index", "index").attr(":key", "item.MessageKey");
                },
                updated: function () 
                {
                    this.$nextTick(function () 
                    {
                        // Code that will run only after the entire view has been re-rendered

                        // Wire up any new tooltips that have appeared, then remove the data-toggle attribute so we don't 
                        // call tooltip() on these elements again. The additional 'svg' filter is because font awesome icons
                        // tend to inherit attributes on the <i> tags, which if they're tooltips, can cause double-rendering issues.
                        $("#homepage-stream [data-toggle=tooltip]:not(svg)").tooltip(
                        {
                            container: '#homepage-stream',
                            sanitize: false,
                            sanitizeFn: function (content) {return content;}
                        })
                        .removeAttr('data-toggle');

                        dn.message.AddEventHandlers();

                        // clicking on a profile avatar should show the profile without collapsing the discussion
                        $('#homepage-stream a.avatar:not(.dn-event-click)').click(function(e) 
                        {
                            if ($(this).parents("div.message").hasClass("not-accessible"))
                            {
                                // This is a message that is inaccessible from a search result
                                dn.PromptToUpgrade("CanSearch");
                                e.preventDefault(); // don't let the link-click work
                            }

                            e.stopPropagation();    // don't let this bubble up
                        })
                        .addClass("dn-event-click");

                        $('a.dn-discussion-title-link:not(.dn-event-click)').click(function(e) 
                        {
                            if ($(this).parents("div.message").hasClass("not-accessible"))
                            {
                                // This is a message that is inaccessible from a search result
                                dn.PromptToUpgrade("CanSearch");
                                e.preventDefault(); // don't let the link-click work
                            }
                            else
                            {
                                dn.stream.Vue.collapse(this);
                            }

                            e.stopPropagation();    // don't let this bubble up
                        })
                        .addClass("dn-event-click");

                        $('div.dn-discussion-item:not(.dn-event-click)').click(function(e) 
                        {
                            if ($(this).parents("div.message").hasClass("not-accessible"))
                            {
                                // This is a message that is inaccessible from a search result
                                dn.PromptToUpgrade("CanSearch");
                                e.preventDefault(); // don't let the link-click work
                            }
                            else
                            {
                                dn.stream.Vue.collapse(this);
                                dn.OpenInNewWindow($(this).find('a.dn-discussion-title-link').attr('href'));
                            }
                        })
                        .addClass("dn-event-click");

                        $('span.dn-stream-downvoted:not(.dn-stream-downvoted-click)').click(function(e) 
                        {
                            e.preventDefault(); // stop the link click
                            e.stopPropagation();    // don't let this bubble up

                            dn.ShowDownvotedModal($(this));
                        })
                        .addClass("dn-stream-downvoted-click");

                        stream.MakeTagsClickable();
                    });
                },
                methods: 
                {
                    /**
                     * Set the search filters and load a fresh set of results.
                     */
                    fetch: function () 
                    {
                        stream.Vue.clear();
                        stream.Vue.setSearchRequest();
                        stream.Vue.loadMore();
                    },
                    /**
                     * Set the search request filters (stream.Vue.SearchRequest).
                     */
                    setSearchRequest: function (useQueryString) 
                    {
                        // Saving this here so we can refer to it in other parts of our stream code.
                        stream.Keywords = ($("#search").val() || dn.QueryString.k || dn.QueryString.q || null);

                        stream.Vue.SearchRequest = 
                        {
                            PageStartIndex: currentPage * dn.constants.MaxMessagesPerPage,
                            PageItemCount: dn.constants.MaxMessagesPerPage,
                            Keywords: stream.Keywords,
                            Topics: stream.Topics,
                            Types: stream.Types,
                            TopicSubscriptionsOnly: (dn.CurrentTopicId === -1),
                            // Without the test for `dn.CurrentTopicId !== -2`, we could inadvertently
                            // cause `TypeSubscriptionsOnly` to be activated even when they are viewing
                            // "My Discussions" views, which could cause weird behavior in some cases.
                            // Without the test for stream.Topics being empty, we'd inadvertently trigger
                            // the addition of all types when a specific topic is chosen.
                            TypeSubscriptionsOnly: (dn.CurrentTypeId === -1 && dn.CurrentTopicId !== -2 && stream.Topics.length === 0),
                            DiscussionsIStarted: (dn.CurrentTopicId === -2),
                            Sort: dn.QueryString.s,
                            // If we want to force results to not include replies, specify nr=1
                            // in the querystring. Since the stream is normally only returning
                            // discussions, this is typically only needed when doing a keyword filter.
                            NoReplies: (dn.QueryString.nr === "1")
                        };

                        if (dn.QueryString.bookmarks === "1")
                        {
                            // they want us to show only bookmarked discussions
                            stream.Vue.SearchRequest.Sort = dn.constants.SortOrderMessages.NewestBookmarks;
                        }
                        else if (!stream.Vue.SearchRequest.Sort && stream.Types && stream.Types.length == 1 && stream.Types[0] == dn.constants.BountyTypeId)
                        {
                            // they are viewing bounties, sort by newest/updated bounties
                            stream.Vue.SearchRequest.Sort = dn.constants.SortOrderMessages.NewestBounties;
                        }

                        if (stream.MakeSelection) 
                        {
                            if (stream.MakeSelection.indexOf("All ") == 0)
                            {
                                if (dn.vehicle.MakeLists[stream.MakeSelection])
                                {
                                    // this handles any "All ..." choices, e.g. "All Ford".
                                    stream.Vue.SearchRequest.Makes = dn.text.Split(dn.vehicle.MakeLists[stream.MakeSelection], ",");
                                }
                                else 
                                {
                                    if (stream.MakeSelection == 'All Heavy Duty')
                                    {
                                        stream.Vue.SearchRequest.VehicleTypeGroup = 8;
                                    }   
                                    else if (stream.MakeSelection == 'All Powersports')
                                    {
                                        stream.Vue.SearchRequest.VehicleTypeGroup = 7;
                                    }
                                    stream.Vue.SearchRequest.Makes = [];
                                }
                            }
                            else
                            {
                                stream.Vue.SearchRequest.Makes = dn.text.Split(stream.MakeSelection, ",");
                            }

                        } else {
                            stream.Vue.SearchRequest.Makes = [];
                        }

                        if (isProfilePage) 
                        {
                            // we're on the user profile page
                            stream.Vue.SearchRequest.UserKey = $("#search-user-messages").val();
                            stream.Vue.SearchRequest.UnreadDiscussionsOnly = false;
                        }
                        else
                        {
                            stream.Vue.SearchRequest.UnreadDiscussionsOnly = stream.UnreadDiscussionsOnly;
                        }

                        if (useQueryString && window.location.search.length > 0)
                        {
                            // If `useQueryString` is true, and there is _some_ sort of querystring, then we 
                            // want to use the querystring parameters to override the Vue.SearchRequest parameters.
                            stream.Vue.SearchRequest.Topics = (typeof dn.QueryString.to === "undefined") ? stream.Vue.SearchRequest.Topics : ($.isArray(dn.QueryString.to) ? dn.QueryString.to : [dn.QueryString.to]);
                            stream.Vue.SearchRequest.Types = (typeof dn.QueryString.ty === "undefined") ? stream.Vue.SearchRequest.Types : ($.isArray(dn.QueryString.ty) ? dn.QueryString.ty : [dn.QueryString.ty]);
                            stream.Vue.SearchRequest.Makes = (typeof dn.QueryString.mk === "undefined") ? [] : ($.isArray(dn.QueryString.mk) ? dn.QueryString.mk : [dn.QueryString.mk]);
                            stream.Vue.SearchRequest.Tags = (typeof dn.QueryString.tag === "undefined") ? [] : ($.isArray(dn.QueryString.tag) ? dn.QueryString.tag : [dn.QueryString.tag]);
                            stream.Vue.SearchRequest.TopicSubscriptionsOnly = ((stream.Vue.SearchRequest.TopicSubscriptionsOnly && dn.QueryString.tos !== "0") || dn.QueryString.tos === "1");
                            stream.Vue.SearchRequest.TypeSubscriptionsOnly = ((stream.Vue.SearchRequest.TypeSubscriptionsOnly && dn.QueryString.tys !== "0") || dn.QueryString.tys === "1");
                            stream.Vue.SearchRequest.DiscussionsIStarted = ((stream.Vue.SearchRequest.DiscussionsIStarted && dn.QueryString.me !== "0") ||dn.QueryString.me === "1");
                            stream.Vue.SearchRequest.UnreadDiscussionsOnly = (dn.QueryString.u === "1");
                            stream.Vue.SearchRequest.VehicleTypeGroup = dn.QueryString.v;
                            stream.Vue.SearchRequest.DateRangeStart = dn.QueryString.drs;
                            stream.Vue.SearchRequest.DateRangeEnd = dn.QueryString.dre;
                            stream.Vue.SearchRequest.Options = dn.QueryString.opt;
                            stream.Vue.SearchRequest.Status = (typeof dn.QueryString.ms === "undefined") ? [] : ($.isArray(dn.QueryString.ms) ? dn.QueryString.ms : [dn.QueryString.ms]);

                            if (!isProfilePage)
                            {
                                stream.Vue.SearchRequest.UserKey = dn.QueryString.uk;
                            }
                        }
                    },
                    /**
                     * Use the existing search filters, and load additional results.
                     */
                    loadMore: function () 
                    {
                        stream.Vue.busy = true;

                        if (done) 
                        {
                            return;
                        }

                        numPageLoads++;

                        // Queue up any StreamOptions changes for this request
                        stream.Vue.SearchRequest.StreamOptions = stream.Options;

                        $.postJSON("/api/v1/messages", stream.Vue.SearchRequest)
                        .done(function (searchResult) 
                        {
                            stream.Options = {}; // reset any queued changes now that we've applied them

                            if (searchResult && searchResult.Messages.length > 0)   //  && searchResult.Messages.Found != 0
                            {
                                var embed = (dn.QueryString.e === "1");
                                stream.TotalDiscussions += searchResult.Messages.length;
                                stream.Vue.processSearchResult(searchResult, embed);
                            } 
                            else 
                            {
                                // show an error message to the user
                                stream.Vue.addMessages
                                ({
                                    Error: (searchResult.Error || dn.stream.Error.NoItems),
                                    Class:
                                    {
                                        Message: ""
                                    }
                                });
                            }
                        })
                        .fail(function (xhr, textStatus, errorThrown) 
                        {
                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                // show an error message to the user
                                stream.Vue.addMessages
                                ({
                                    Error: dn.stream.Error.LoadingItems,
                                    Class:
                                    {
                                        Message: ""
                                    }
                                });
                            }
                        });
                    },
                    processSearchResult: function (searchResult, isEmbedded) 
                    {
                        // Add any downloaded Topic objects to our local cache, so that we
                        // are guaranteed being able to reference constants.Topics directly...
                        $.extend(dn.constants.Topics, searchResult.Topics);

                        searchResult.Messages.forEach
                        (
                            function(message)
                            {
                                try 
                                {
                                    // See if the user is (a) logged in, and (b) has muted the current author at all, and (c) the relationship's (or the user's, or the site-wide) MuteSettings dictate that this root message (or reply) be shown.
                                    if (dn.user.IsLoggedIn && (message.Author.UserKey in dn.user.MutedUsers) && !dn.HasFlag(dn.user.MutedUsers[message.Author.UserKey], (message.IsRoot ? dn.constants.MuteFlags.DiscussionNewShow : dn.constants.MuteFlags.DiscussionReplyShow)))
                                    {
                                        // TODO: Eventually we should display somewhere how many messages in this stream are being hidden, and let them show them, not just obliterate.
                                        return;
                                    }

                                    if (stream.Messages[message.MessageKey])
                                    {
                                        // Encountered a duplicate message that is already visible, probably by scrolling
                                        // down the page after someone else has posted a new message to the same stream.
                                        // Just skip this message processing and move on to the next one. 
                                        return;
                                    }

                                    stream.Messages[message.MessageKey] = true; // We could store the `message` variable here if we needed access to that info, but for now, we'll go lightweight

                                    // Preset a few things that may get overridden later.
                                    message.ShowSignature = false;

                                    if (message.TypeId === dn.constants.AnnouncementTypeId)
                                    {
                                        // This IS an announcement, but we don't bother showing these if we're currently embedded.
                                        if (isEmbedded)
                                        {
                                            return; // don't show announcements if we're embedded
                                        }
                                        else
                                        {
                                            message.IsAnnouncement = true;
                                        }
                                    }
                                    else
                                    {
                                        message.IsAnnouncement = false;

                                        if (!isProfilePage)
                                        {
                                            // Show the user "signature" if this isn't an announcement and this isn't a profile page
                                            message.ShowSignature = true;
                                        }
                                    }

                                    // Convert a few dates to MomentJS objects for some necessary functionality
                                    message.DateLastReplied = moment(message.DateLastReplied);
                                    message.DateCompleted = moment(message.DateCompleted);

                                    // If DateLastReplied is set/real, we'll show it in the tooltip
                                    message.DisplayDate = (message.DateLastReplied.unix() > 0) ? dn.FormatDateHtml(message.DateLastReplied.locale('en-short'), 'Latest: ', '<br>Started: ' + message.DateCompleted.format("llll")) : dn.FormatDateHtml(message.DateCompleted.locale('en-short'), 'Started: ');

                                    message.StatusName = dn.message.StatusReverse[(message.Status || dn.message.Status.Default)];

                                    // We'll show total number of replies, unless we find out later they've read the
                                    // message already and there are new replies since their last visit.
                                    message.DisplayNumReplies = message.ReplyCount;

                                    var metadata = searchResult.Metadata[message.DiscussionKey];

                                    if (metadata && metadata.DateLastSeen)
                                    {
                                        // The viewer HAS seen the message
                                        message.DateLastSeen = moment(metadata.DateLastSeen);
                                        message.ToolTipReplies = "";

                                        message.Class = 
                                        {
                                            Message:    "collapsed" + (message.Link === null ? " not-accessible" : ""),
                                            NewReplies: "",
                                            Replies:    "fal fa-comments-alt",
                                            Tag:        "fal fa-tag",
                                            VoteDown:   "fal fa-arrow-alt-down",
                                            VoteUp:     "fal fa-arrow-alt-up",
                                        };

                                        if (metadata.NumNewReplies > 0)
                                        {
                                            // There are new replies this specific user hasn't seen
                                            message.Class.NewReplies = "newreplies";
                                            message.Class.Replies = "fas fa-comments-alt";
                                            message.DisplayNumReplies = metadata.NumNewReplies;
                                            message.ToolTipReplies = "New replies since your last viewing";
                                        }
                                    }
                                    else
                                    {
                                        // The viewer has NEVER seen this message
                                        message.DateLastSeen = 0;
                                        message.ToolTipReplies = "";

                                        message.Class = 
                                        {
                                            Message:    (message.Link === null ? " not-accessible" : ""),
                                            NewReplies: "",
                                            Replies:    "fas fa-comments-alt",
                                            Tag:        "fas fa-tag",
                                            VoteDown:   "fas fa-arrow-alt-down",
                                            VoteUp:     "fas fa-arrow-alt-up",
                                        };
                                    }

                                    message.DateBookmarked = metadata ? metadata.DateBookmarked : null;

                                    if (message.IsRoot)
                                    {
                                        message.ThresholdVotes = dn.constants.ThresholdDiscussionVoteMinimum;
                                    }
                                    else
                                    {
                                        message.Title = "Re: " + message.Title;
                                        message.ThresholdVotes = dn.constants.ThresholdReplyVoteMinimum;
                                    }

                                    // Show tags if ANY of the following is true:
                                    // 
                                    //  - The tag was used by 2+ taggers, or
                                    //  - The tag is an official community tag (UserId=0), or
                                    //  - The viewer is the tagger
                                    message.NumTags = 0;
                                    message.DisplayTags = '';

                                    if (message.Tags.length > 0)
                                    {
                                        var tagSuffix = '';

                                        message.Tags.forEach
                                        (
                                            function(tag)
                                            {
                                                tagSuffix = '';

                                                if (tag.NumUses > 1)
                                                {
                                                    // tagged by multiple people, reflect in the tag suffix, and count it as a visible tag
                                                    tagSuffix = ' (' + tag.NumUses + ')';
                                                }
                                                else if (dn.constants.TagsOfficial[tag.TagId] !== true && !message.UserTags.some(function(t) { return (t.TagId === tag.TagId) })) // did the user use this tag?
                                                {
                                                    // not tagged more than once, not an official tag, and not tagged by this user, so skip it
                                                    return;
                                                }

                                                message.NumTags++;
                                                message.DisplayTags += ', ' + tag.Name + tagSuffix;
                                            }
                                        );

                                        message.DisplayTags = message.DisplayTags.substring(2); // lop off the beginning ", " separator
                                    }

                                    // here is where we store info for our embeds
                                    message.EmbedSources = [];
                                    message.EmbedTypes = [];

                                    // TODO: We're doing a FOR loop here, and also a V-FOR loop in the Vue template.
                                    // Is there some way we can combine these two loops into one? Put this stuff in the template?
                                    for (var idx = 0; idx < message.FileTypes.length; idx++)
                                    {
                                        if ((message.FileTypes[idx] & dn.constants.FileTypes.Image) != 0)
                                        {
                                            // image
                                            message.EmbedSources.push('/file/' + message.FileKeys[idx] + '/lg');
                                            message.EmbedTypes.push('');
                                        }
                                        else
                                        {
                                            // something other than image (use /embed)
                                            message.EmbedSources.push('/file/' + message.FileKeys[idx] + '/embed');
                                            message.EmbedTypes.push('iframe');
                                        }
                                    }

                                    stream.Vue.addMessages(message);
                                }
                                catch (e) 
                                {
                                    Sentry.captureException(e);

                                    try 
                                    {
                                        Sentry.captureMessage("Error on homepage stream - cannot load message: " + message.Id + ". We showed an error message in the feed and attempted to continue displaying the other messages.");
                                    } 
                                    catch (e2) 
                                    { 
                                        Sentry.captureException(e2); 
                                    }

                                    message = 
                                    {
                                        Error: dn.stream.Error.RenderingItem,
                                        Class:
                                        {
                                            Message: ""
                                        }
                                    };

                                    stream.Vue.addMessages(message);
                                }
                            }
                        );

                        // stop once there are zero hits for this particular page (this can happen if you remove search 
                        // results server-side without decrementing the found count), OR things unexpectedly somehow get 
                        // out of control and we have to force-stop the requests
                        done = (searchResult.Messages.length === 0 || numPageLoads > maxPageLoads);

                        currentPage++;
                        stream.Vue.SearchRequest.PageStartIndex = currentPage * dn.constants.MaxMessagesPerPage;

                        stream.Vue.busy = false;
                    },
                    addMessages: function (element) 
                    {
                        stream.Vue.Messages.push(element);
                    },
                    clear: function () 
                    {
                        stream.Vue.busy = true;

                        stream.Messages = {};
                        stream.Vue.Messages = [];
                        currentPage = 0;
                        stream.TotalDiscussions = 0;
                        done = false;

                        stream.Vue.busy = false;
                    },
                    collapse: function (element) 
                    {
                        $(element).closest(".message").addClass('collapsed newly-collapsed');
                        var discussionItem = $(element).closest('.dn-discussion-item');
                        discussionItem.find(".homepage-comments").find('svg[data-fa-i2svg]').attr('data-prefix', 'fal');
                        discussionItem.find(".homepage-votes").find('svg[data-fa-i2svg]').attr('data-prefix', 'fal');
                    }
                }
            }
        );

        Vue.component('message-line-item', 
        {
            props: ['message', 'vueIndex'],
            template: '<div :class="message.Class.Message" :data-vue-index="vueIndex">\
                <template v-if="message.Error">\
                    <div v-if="message.Error === dn.stream.Error.LoadingItems" class="alert alert-danger mb-0">There was a problem loading more messages. <a href="#" onclick="dn.stream.Vue.loadMore(); return false;">Retry</a></div>\
                    <template v-else-if="message.Error === dn.stream.Error.NoItems">\
                        <template v-if="dn.stream.TotalDiscussions === 0">\
                            <div v-if="dn.QueryString.bookmarks === \'1\'" class="alert alert-secondary mb-0">No matching bookmarks found. <a href=\"/help#bookmarking\">Learn more about bookmarks.</a></div>\
                            <div v-else-if="dn.CurrentTopicId > 0 && !dn.stream.Keywords && dn.stream.Types.length === 0 && dn.constants.Topics[dn.CurrentTopicId].IsEnabled" id="dn-start-the-discussion" class="mt-3 mb-0">\
                                <button type="button" class="btn btn-success" onclick="dn.compose.StartPost(null, \'#dn-start-the-discussion\');"><i class="fas fa-pen"></i> Start the Discussion</button>\
                                <div class="mt-2">Be the first to post in this {{dn.constants.Topics[dn.CurrentTopicId].IsGroup ? "group" : "topic"}}!</div>\
                            </div>\
                            <div v-else class="alert alert-warning mb-0">No messages found.</div>\
                        </template>\
                    </template>\
                    <div v-else-if="message.Error.Message" class="alert alert-danger mb-0"><div class="d-block" v-html="message.Error.Message"></div><div class="d-block mt-2"><pre>{{message.Error.Debug}}</pre></div></div>\
                    <div v-else class="alert alert-danger mb-0">Oops! There was a problem displaying this message.</div>\
                </template>\
                <div v-else class="list-group-item list-group-item-action dn-discussion-item" :class="{ \'dn-announcement\': message.IsAnnouncement }">\
                    <div class="media dn-discussion">\
                        <a v-if="!message.IsAnonymized && message.ShowSignature" :href="message.Author.Link" class="avatar avatar-square" target="' + dn.constants.LinkTargetNewWindow + '">\
                            <img alt="User Avatar" :src="message.Author.UrlProfilePhoto" class="avatar avatar-square" :class="\'avatar-\'+message.Author.UserKey"/>\
                        </a>\
                        <div class="media-body"><div class="col-auto order-2 dn-stream-metadata"><div><i v-if="message.DateBookmarked" data-toggle="tooltip" :title="\'Bookmarked: \' + moment(message.DateBookmarked).format(\'llll\')" class="fas fa-bookmark mr-1"></i><span v-if="message.NumTags > 0" class="homepage-tags mr-1" :title="message.DisplayTags">{{message.NumTags}}<i :class="message.Class.Tag"></i></span><span v-if="message.Votes != 0" class="homepage-votes mr-1" :class="{ \'dn-stream-downvoted\': message.Votes < message.ThresholdVotes}" :data-userkey="message.Author.UserKey" :data-isadmin="message.Author.IsAdministrator" :data-ismanager="message.Author.IsManager">{{message.Votes}}<i v-if="message.Votes > 0" :class="message.Class.VoteUp"></i><i v-if="message.Votes < 0" :class="message.Class.VoteDown"></i></span><span v-if="message.ReplyCount > 0" class="homepage-comments mr-1" :title="message.ToolTipReplies" data-toggle="tooltip" :class="message.Class.NewReplies">{{message.DisplayNumReplies}}<i :class="message.Class.Replies"></i></span><span class="homepage-activity"><span class="" v-html="message.DisplayDate"></span></span></div></div><div class="col-12 order-1 pl-0 dn-title-sig"><a :href="message.Link" class="dn-discussion-title-link" target="' + dn.constants.LinkTargetNewWindow + '"><div class="dn-discussion-title">{{message.Title}}</div><div class="dn-discussion-signature" v-if="message.ShowSignature">{{message.Author.FirstName}}<span v-if="message.Author.LastName"> {{message.Author.LastName}}<span v-if="message.Author.BusinessName">, <span>{{message.Author.Position}}<span class="d-sm-inline d-none"> at <i>{{message.Author.BusinessName}}</i></span></span></span></span> in {{message.Author.BusinessLocation}}</div></a></div></div>\
                    </div>\
                    <div class="dn-discussion-content">\
                        <p><a :href="message.Link" class="dn-discussion-title-link" target="' + dn.constants.LinkTargetNewWindow + '" v-html="message.Snippet"></a></p>\
                        <div v-if="message.FileKeys.length" class="has-attachments dn-attachments clearfix" >\
                            <div v-for="(fileKey, index) in message.FileKeys" :id="fileKey" :data-fancybox-trigger="[\'gallery-\' + message.MessageKey]" :data-src="message.EmbedSources[index]" :data-filetype="message.FileTypes[index]" :data-type="message.EmbedTypes[index]" :class="[message.FileTypes[index] === 32 ? \'dn-file-wrapper dn-gallery mr-1 mb-1 float-left video-thumbnail-overlay\' : \'dn-file-wrapper dn-gallery mr-1 mb-1 float-left\']"><img :src="[\'/file/\' + fileKey + \'/sm\']" class="img-fluid mh-100 img-svg rounded"/></div>\
                        </div>\
                        <div class="mt-2 dn-tag-boxes">' +

                            // Types

                            '<a :href="\'/\' + dn.constants.DiscussionTypes[message.TypeId].TypeKey" :data-type-id="message.TypeId" class="dn-type-link"><div v-if="message.TypeId === dn.constants.BountyTypeId && message.Bounty && message.Bounty.Amount > 0 && message.Bounty.IsOpen" :class="[\'dn-type\', \'dn-type-\' + dn.constants.DiscussionTypes[message.TypeId].TypeKey, \'dn-message-status-\' + message.StatusName, \'dn-bounty-open\']">{{dn.constants.DiscussionTypes[message.TypeId].Name}} <span class="dn-bounty-badge">' + dn.constants.TokenCurrencySymbolHtml + '{{dn.DecimalToString(message.Bounty.Amount, 2)}}</span></div><div v-else :class="[\'dn-type\', \'dn-type-\' + dn.constants.DiscussionTypes[message.TypeId].TypeKey, \'dn-message-status-\' + message.StatusName]">{{dn.constants.DiscussionTypes[message.TypeId].Name}}</div></a>' + 
                            
                            // Topics

                            '<template v-for="topic in message.Topics"><a v-if="topic != dn.CurrentTopicId" :href="dn.constants.Topics[topic].LinkRelative" :data-topic-id="topic" class="dn-topic-link"><div class="dn-topic" :style="{backgroundColor: dn.constants.Topics[topic].ColorPrimary, color: dn.constants.Topics[topic].ColorText}"><i :class="dn.topic.GetIconClass(dn.constants.Topics[topic].Type)" data-toggle="tooltip" :title="dn.constants.TopicTypeNames[dn.constants.Topics[topic].Type]"></i> {{dn.constants.Topics[topic].Name}}</div></a></template>' +

                            // Metadata

                            '<template v-for="metadata in dn.constants.DiscussionTypes[message.TypeId].Template.Fields.map(function(field) { return dn.constants.Metadata[field.MetadataId]; })"><template v-if="message.Metadata[metadata.MetadataKey]"><template v-for="item in message.Metadata[metadata.MetadataKey]"><div class="dn-metadata" :style="{backgroundColor: metadata.ColorPrimary, borderColor: metadata.ColorPrimary, color: metadata.ColorText}" data-toggle="tooltip" :title="metadata.Options.Render.ItemPopoverTemplate(item)"><i :class="metadata.Options.Render.Icon"></i> <span v-html="metadata.Options.Render.StreamBodyTemplate(item)"></span></div></template></template></template>' +

                        '</div>\
                    </div>\
                </div>\
            </div>'
        });

        // Make tag boxes clickable even before the discussions load.
        // E.g. this might link up the topic filter header.
        stream.MakeTagsClickable();

        if (!isProfilePage)
        {
            dn.vehicle.SetMakeChoices($('div.dn-make-dropdown'), true);
            $('.dn-make-dropdown .dropdown-item').click(stream.SetMakeSelection);

            // Perform the search if someone presses ENTER key in keyword box
            $(document).on
            (
                'keydown',  // case insensitive, sees all keys (compared to keypress, case sensitive and ignores CTRL/SHIFT/ALT)
                '.dn-search-box > input#search', 
                function(e) 
                {
                    if (e.which === 13) 
                    {
                        stream.Vue.fetch();
                        return false;
                    }
                }
            );

            // Perform the search if someone clicks the search button
            $('.dn-search-box .btn').click(function(e) 
            {
                stream.Vue.fetch();
            });

            // Set Type stream filters
            $('div.dn-filter-dropdown .dn-filter-type').click(function(e) {

                e.preventDefault();     // don't let this trigger the href link click

                // Chose a type filter
                var typeId = $(this).data('type-id');
                stream.SetTypeSelection(typeId, true);

            }).on('touchstart', function() {}); // TODO: Any way to replace this hack? We've got this here just so that taps on mobile appear "active"

            // Set Topic stream filters
            $('div.dn-filter-dropdown .dn-filter-topic, .dn-meta-box nav > a.dn-topic-link').click(function(e) {

                e.preventDefault();     // don't let this trigger the href link click

                // Chose a topic filter, possibly also "All Messages"
                var topicId = $(this).data('topic-id');
                var typeId = $(this).data('type-id');

                if (topicId == -1)
                {
                    // Explicitly selected "Subscriptions", so queue that setting to be recorded as our stream preference
                    stream.Options.Filter = -1;
                }
                else if (topicId == -2)
                {
                    // Selected "My Discussions", see if we're toggling it on or off
                    if ($(this).hasClass('dropdown-selected'))
                    {
                        // toggle "My Discussions" off
                        delete dn.QueryString["mine"];
                        $(this).removeClass('dropdown-selected');

                        if (stream.Options.Filter === -1 || dn.user.StreamOptions.Filter === -1)
                        {
                            topicId = -1;
                            typeId = -1;
                        }
                        else
                        {
                            topicId = 0;
                            typeId = 0;
                        }
                    }
                    else
                    {
                        // toggle "My Discussions" on
                        dn.QueryString["mine"] = "1";
                        $(this).addClass('dropdown-selected');
                    }
                }
                else if (topicId == 0)
                {
                    if (typeId == 0)
                    {
                        // Explicitly selected "All Messages", so queue that setting to be recorded as our stream preference
                        stream.Options.Filter = 0;
                    }
                }

                if (typeof typeId !== 'undefined')
                {
                    dn.CurrentTypeId = parseInt(typeId);
                    stream.Type = '';
                    stream.Types = [];
                }

                stream.SetTopicSelection(topicId, true);

            }).on('touchstart', function() {}); // TODO: Any way to replace this hack? We've got this here just so that taps on mobile appear "active"

            // Toggle Bookmarks
            $('div.dn-filter-dropdown .dn-filter-bookmarks, .dn-bookmarks-flag').click(function(e) {

                e.preventDefault();     // don't let this trigger the href link click

                if ($(this).hasClass('dn-bookmarks-flag'))
                {
                    // they clicked on the bookmark icon in the title, don't let this bubble up
                    // or it will just toggle open the menu instead of actually taking the action.
                    e.stopPropagation();
                }

                if (dn.QueryString.bookmarks === "1")
                {
                    // turn off bookmarks
                    delete dn.QueryString["bookmarks"];
                    $(".dn-bookmarks-flag").addClass("d-none");
                    $("div.dn-filter-dropdown .dn-filter-bookmarks").removeClass('dropdown-selected');
                }
                else
                {
                    // turn on bookmarks
                    dn.QueryString["bookmarks"] = "1";
                    $(".dn-bookmarks-flag").removeClass("d-none");
                    $("div.dn-filter-dropdown .dn-filter-bookmarks").addClass('dropdown-selected');
                }

                // Hide any visible tooltips
                $('.bs-tooltip-top.show').remove();

                stream.SetFilters(true);

            }).on('touchstart', function() {}); // TODO: Any way to replace this hack? We've got this here just so that taps on mobile appear "active"

            // Handle clicks when they click the edit gear next to Subscriptions
            $('span.dn-edit-subscriptions').click(function(e) {
                e.preventDefault();     // don't let this trigger the href link click
                e.stopPropagation();    // don't let this bubble up
                $('.dn-filter-dropdown-toggle').dropdown('toggle');
                window.location.href = '/topics';
            });

            $('.homepage div.dropdown').on('show.bs.dropdown', function(event) {
                $('.dn-filter-dropdown-backdrop').show();
            });

            $('.homepage div.dropdown').on('hide.bs.dropdown', function(event) {
                $('.dn-filter-dropdown-backdrop').hide();
            });

            stream.SetFilterMenu();
            $(window).resize(stream.SetFilterMenu);

            // Initial setup of the search filters for homepage stream
            stream.SetTypeSelection($('.homepage').data('type-id') || 0, false); // try to find out our starting type
            stream.SetTopicSelection(dn.CurrentTopicId, false); // try to find out our starting topic

            // Make "Post Bounty" links clickable.
            $('.dn-post-bounty').click(function(e) {
                dn.compose.StartPost(dn.constants.BountyTypeId);
            });

            // Make "Create" user group links clickable
            $('.dn-create-group').click(function() {
                dn.topic.CreateOrUpdate();
            });
        }

        stream.Vue.setSearchRequest(true);

        // toggle our popovers
        $('[data-toggle="popover"]').popover();
    };

    /**
     * Make our tag boxes (and related filters) clickable.
     * 
     * When someone clicks a topic box, trigger the stream.Vue.fetch()
     * (which will in turn change the URL of the page to an appropriate URL),
     * but stop the event propagation so that the actual link is not followed.
     * This way Google can index and go to the /t/<topic> URL in the link, but
     * normal users will just trigger an ajax request, which is much faster.
     */
    stream.MakeTagsClickable = function()
    {
        $('a.dn-topic-link:not(.dn-event-click)').click(function(e) 
        {
            e.stopPropagation();    // don't let this bubble up and collapse the message
            e.stopImmediatePropagation(); 

            if (!isProfilePage)
            {
                e.preventDefault();     // don't let this trigger the href link click
                stream.SetTopicSelection($(this).data('topic-id'), true);
            }
        })
        .addClass("dn-event-click");

        $('a.dn-type-link:not(.dn-event-click)').click(function(e) 
        {
            e.stopPropagation();    // don't let this bubble up and collapse the message
            e.stopImmediatePropagation(); 

            if (!isProfilePage)
            {
                e.preventDefault();     // don't let this trigger the href link click
                stream.SetTypeSelection($(this).data('type-id'), true);
            }
        })
        .addClass("dn-event-click");
    };

    /**
     * This is called when the user choose a make from the search filter area. We will
     * then filter the stream down to the given make(s). The given make identifier can also
     * be a negative number, indicating a special group of makes, such as "All Asian."
     */
    stream.SetMakeSelection = function(event)
    {
        $('#dn-makes-dropdown').find('.dropdown-item.dropdown-selected').removeClass("dropdown-selected");

        var make = $(this).data('make');    // retain this value for use below

        if (make)
        {
            if (make === "-all")
            {
                stream.SetAllMakes();

                dn.vehicle.SetMakeChoices($('div.dn-make-dropdown'), false);
                $('.dn-make-dropdown .dropdown-item').click(stream.SetMakeSelection);
                setTimeout(function() { 
                    $('#make-select').click(); 
                    $('#dn-makes-dropdown').animate({
                        scrollTop: 0
                    }, 'fast');
                }, 300);
            }
            else if (make === "-popular")
            {
                stream.SetAllMakes(); // Set this in case they choose nothing from the new list

                dn.vehicle.SetMakeChoices($('div.dn-make-dropdown'), true);
                $('.dn-make-dropdown .dropdown-item').click(stream.SetMakeSelection);
                setTimeout(function() { 
                    $('#make-select').click(); 
                    $('#dn-makes-dropdown').animate({
                        scrollTop: 0
                    }, 'fast');
                }, 300);
            }
            else if (make < 0) // value is -2, -7, -8, where the number is VehicleTypeGroupId
            {
                stream.SetAllMakes(); // Set this in case they choose nothing from the new list

                // second character is the VehicleTypeGroupId
                dn.vehicle.SetMakeChoices($('div.dn-make-dropdown'), false, parseInt(Math.abs(make)));
                $('.dn-make-dropdown .dropdown-item').click(stream.SetMakeSelection);
                setTimeout(function() { 
                    $('#make-select').click(); 
                    $('#dn-makes-dropdown').animate({
                        scrollTop: 0
                    }, 'fast');
                }, 300);
            }
            else
            {
                stream.MakeSelection = make;
                $(this).addClass("dropdown-selected");
                $('#make-select').text(make).val(make);
                stream.Vue.fetch();
            }
        }
        else
        {
            stream.SetAllMakes();
            stream.Vue.fetch();
        }
    };

    /**
     * Adjust placement of the stream filter menu, depending on location of the toggling button,
     * responsive layout, device dimensions, etc.
     */
    stream.SetFilterMenu = dn.Debounce(function() {

        if (dn.user.IsLoggedIn)
        {
            // Only remove the top/right curved corner when the dropdown is near the top of our page
            $('#dn-filter-list').css('border-top-right-radius', 0);
        }

        var docWidth = $(document).width();

        if (docWidth < 992)
        {
            $('#dn-filter-list').css('top', $('#filter-select').offset().top - (dn.user.IsLoggedIn && docWidth > 374.98 ? 100 : 84));
        }
        else
        {
            $('#dn-filter-list').css('top', $('#filter-select').offset().top - 98);
        }

    }, 10, false); // wait 10 ms before executing, to see if we are processing multiple requests;

    /** 
     * Reset to All Makes as their choice.
     */
    stream.SetAllMakes = function()
    {
        stream.MakeSelection = ''; 
        $('#make-select').find(".dropdown-item").first().addClass("dropdown-selected");
        $('#make-select').text('All Makes').val('');
    }

    /**
     * Set the ad on the stream for the given PartnerId. If no partner id is given, we'll set
     * a random partner. 
     */
    stream.SetPartner = function(partnerId, key)
    {
        if ($(".dn-partner").length)
        {
            if (partnerId > 0)
            {
                var partner = stream.Partners[partnerId];
                if (partner)
                {
                    // Construct the ad and replace the existing one with this one.
                    $(".dn-partner").html($('<div class="card card-borderless bg-secondary mb-1 dn-partner">\
                        <a class="card-body" href="/redirect?key=' + key + "/" + partner.PartnerId + '" target="' + dn.constants.LinkTargetNewWindow + '" rel="nofollow noopener">\
                            <div class="justify-content-between mb-3">\
                                <img class="dn-partner-logo img-fluid" alt="' + partner.DisplayName + '" src="' + partner.LogoUrl + '" />\
                            </div>\
                            <span class="h6">' + partner.Description + '</span>\
                            <span class="title-decorative">Corporate Partner</span>\
                        </a>\
                    </div>'));
                }
                else
                {
                    // This Partner is not yet cached, so look them up.
                    $.get("/api/v1/partner/" + partnerId)
                    .done(function(partner) {
                        // We found the partner, so construct the ad
                        stream.Partners[partner.PartnerId] = partner;
                        // Call this function again, but this time the partner has been cache
                        stream.SetPartner(partner.PartnerId, key);
                    });
                }
            }
            else
            {
                // Get a random partner
                $.get("/api/v1/partner/__random__") // special key used to designate a random partner
                .done(function(partner) {
                    // We found the partner, so construct the ad
                    stream.Partners[partner.PartnerId] = partner;
                    // Call this function again, but this time the partner has been cache
                    stream.SetPartner(partner.PartnerId, key);
                });
            }
        }
    };

    /**
     * Change the current stream view to the given TopicId. This will cause the 
     * stream to be filtered to the given topic THE NEXT TIME YOU CALL stream.Vue.fetch() or
     * loadMore(), and the URL of the page to change to that topic.
     * 
     * @param (int) topicId - The TopicId as defined in our database, or a negative value
     *                        to indicate a specially handled topic filter, such as All Topics.
     * @param (bool) fetch  - If true, fetch a new set of discussions after setting the topic.
     */
    stream.SetTopicSelection = function(topicId, fetch)
    {
        dn.CurrentTopicId = topicId;

        if (dn.CurrentTopicId > 0)
        {
            stream.Topics = [dn.CurrentTopicId];

            // Fill the topic-meta box with data and show it
            dn.topic.Lookup(
            {
                topicIdOrKey: dn.CurrentTopicId, 
                showAjaxSpinner: false, 
                onSuccess: function(topic) 
                {
                    // Set the topic description
                    $('.dn-filter-dropdown .dn-topic-description').html((topic.Description ? topic.Description + ' ' : '') + '<a class="text-nowrap" href="' + topic.LinkDetailsRelative + '">Details.</a>');
                    $('.dn-filter-dropdown .dn-topic-description').removeClass('d-none').addClass('d-inline-block');

                    // If this topic has a BannerPartnerId, it'll cause the ad to be replaced here.
                    stream.SetPartner(topic.BannerPartnerId, "partners/topic/" + topic.TopicId);

                    if (topic.TopicId != $('.right-side .dn-topic-box').data('topic-id')) // see if chosen topic is changing
                    {
                        // Set the contents of the dn-topic-box on the right side, and show it. If
                        // this layout needs to change, make sure to update dn-topic-box in Home/Index.cshtml
                        var topicBox = '<div class="card-body"><h5 class="mb-2">' + topic.Name + '</h5><p>' + (topic.Description || '') +  '</p><ul class="list-inline text-small text-nowrap"><li class="list-inline-item mr-1 mr-xl-2"><i class="' + dn.topic.GetIconClass(topic.Type) + ' mr-1"></i>' + dn.constants.TopicTypeNamesShort[topic.Type] + '</li><li class="list-inline-item mr-1 mr-xl-2"><i class="fas fa-user-friends"></i> <span id="dn-group-subscriber-count">' + topic.NumSubscribers + '</span></li><li class="list-inline-item mr-1 mr-xl-2 d-inline d-md-none d-xl-inline"><i class="fas fa-comments-alt"></i> ' + topic.NumMessages + '</li><li class="list-inline-item mr-1 mr-xl-2"><a href="' + topic.LinkDetailsRelative + '"><i class="fas fa-info-circle text-body"></i> Details</a></li></ul>';

                        var topicSubscribeButton = '';

                        var className = "not-subscribed";
                        var label = "Subscribe";

                        if (dn.user.IsLoggedIn)
                        {
                            if (dn.user.TopicSubscriptions.indexOf(topic.TopicId) > -1)
                            {
                                className = "subscribed";
                                label = "Subscribed";
                            }
                            else if (dn.user.TopicSubscriptionsPending.indexOf(topic.TopicId) > -1)
                            {
                                className = "pending";
                                label = "Pending";
                            }
                            else if (dn.user.TopicSubscriptionsRejected.indexOf(topic.TopicId) > -1)
                            {
                                className = "rejected";
                                label = "Unavailable";
                            }
                        }

                        topicSubscribeButton = '<button class="btn btn-block btn-subscribe-topic ' + className + '" id="group-' + topic.TopicId + '" data-topic-id="' + topic.TopicId + '" data-topic-key="' + topic.TopicKey + '" data-topic-name="' + topic.Name + '" data-topic-required-badges="' + JSON.stringify(topic.RequiredBadges) +  '"><i class="far fa-check"></i>' + label + '</button>';

                        topicBox += topicSubscribeButton + '</div>';

                        $('.right-side .dn-topic-box').html(topicBox).data('topic-id', topic.TopicId).removeClass('d-none');

                        // Also replace the button in the dropdown menu
                        $('.dropdown-menu div.dn-topic-subscribe').html(topicSubscribeButton);

                        // Re-wire these buttons
                        $('.btn-subscribe-topic').off('click').click(dn.topic.HandleSubscribeClick);
                    }
                }, 
                onError: function() {
                    console.error('Failed to find the topic or user group: ' + dn.CurrentTopicId);
                }
            });
        }
        else
        {
            stream.Topics = [];

            if (dn.CurrentTopicId == -1)
            {
                if (dn.CurrentTypeId == -1)
                {
                    stream.ShowSubscriptionExplanation();
                }
            }
            else
            {
                // Hide the topic-meta box
                $('.dn-filter-dropdown .dn-topic-description').removeClass('d-inline-block').addClass('d-none');

                // Hide the topic-box on the right side
                $('.right-side .dn-topic-box').addClass('d-none');
            }
        }

        stream.ResetDropdownSelections();
        stream.SetFilters(fetch);
    };

    /**
     * Change the current stream view to the given TypeId. This will cause the 
     * stream to be filtered to the given topic THE NEXT TIME YOU CALL stream.Vue.fetch() or
     * loadMore(), and the URL of the page to change to that topic.
     * 
     * @param (int) typeId  - The TypeId as defined in our database, or a negative value
     *                        to indicate a specially handled type filter, such as All Types.
     * @param (bool) fetch  - If true, fetch a new set of discussions after setting the type.
     */
    stream.SetTypeSelection = function(typeId, fetch)
    {
        dn.CurrentTypeId = typeId;

        if (dn.CurrentTypeId > 0)
        {
            var type = dn.constants.DiscussionTypes[typeId];
            stream.Type = type.TypeKey;
            dn.CurrentTypeId = typeId;
            stream.Types = [typeId];

            // If this type has a BannerPartnerId, it'll cause the ad to be replaced here.
            stream.SetPartner(type.BannerPartnerId, "partners/type/" + typeId);
        }
        else
        {
            stream.Type = '';
            stream.Types = [];

            if (dn.CurrentTypeId == -1)
            {
                if (dn.CurrentTopicId == -1)
                {
                    stream.ShowSubscriptionExplanation();
                }
            }
            else
            {
                // Hide the type-meta box
                // $('.dn-filter-dropdown .dn-topic-description').removeClass('d-inline-block').addClass('d-none');

                // Hide the topic-box on the right side
                // $('.right-side .dn-topic-box').addClass('d-none');
            }
        }

        $('.homepage').data('type-id', typeId);

        stream.ResetDropdownSelections();
        stream.SetFilters(fetch);
    };

    /**
     * Called in places where the dn.CurrentTopicId or dn.CurrentTypeId is changing, such
     * as when All Messages, Subscriptions, or specific topics, types are selected.
     */
    stream.ResetDropdownSelections = function()
    {
        // Adjust Topic Selections
        $('#dn-filter-list').find('.dn-filter-topic.dropdown-selected').removeClass("dropdown-selected");
        $('#dn-filter-list .dn-filter-topic').filter('[data-topic-id="' + dn.CurrentTopicId + '"]').addClass("dropdown-selected");

        // adjust topic highlighting in the Trending box
        $('.dn-meta-box nav>a.active').removeClass('active');
        $('.dn-meta-box nav>a.dn-topic-' + dn.CurrentTopicId).addClass('active');

        // Adjust Type Selections
        $('#dn-filter-list').find('.dn-filter-type.dropdown-selected[data-type-id]').removeClass("dropdown-selected");
        $('#dn-filter-list .dn-filter-type').filter('[data-type-id="' + dn.CurrentTypeId + '"]').addClass("dropdown-selected");
    };

    /**
     * Show the subscription explanation in the sidebar and dropdown filter areas.
     */
    stream.ShowSubscriptionExplanation = function()
    {
        // Explain the Subscriptions feed on the right side column, where we put topic/group/type details.
        var subscriptionsDescription = "Showing only messages posted in topics, user groups, and message types to which you've subscribed.";
        var topicSubscribeButton = '<a class="btn btn-block dn-button dn-edit-subscriptions" href="/topics">Edit Subscriptions</a>';
        var topicBox = '<div class="card-body"><h5 class="mb-2">Subscriptions</h5><p>' + subscriptionsDescription + '</p>' + topicSubscribeButton + '</div>';

        $('.right-side .dn-topic-box').html(topicBox).data('topic-id', dn.CurrentTopicId).removeClass('d-none');

        // Explain what subscriptions are in the topic description area of the stream filter menu
        $('.dn-filter-dropdown .dn-topic-description').html(subscriptionsDescription).removeClass('d-none').addClass('d-inline-block');

        // Also replace the button in the dropdown menu
        $('.dropdown-menu div.dn-topic-subscribe').html(topicSubscribeButton);
    };

    /**
     * Called by SetTopicSelection and SetTypeSelection, this method adjusts the URL the user sees in their
     * browser, sets the stream label shown at the top of the stream, adjusts the type/topic selections for
     * an open compose form in certain cases, and if `fetch` is true, immediately fetches filtered stream results.
     */
    stream.SetFilters = dn.Debounce(function(fetch)
    {
        var streamTitle = '';
        var embed = (dn.QueryString.e === "1");

        if (dn.CurrentTopicId < 1)
        {
            // Clear elements from our querystring that may be getting reset
            delete dn.QueryString["subscriptions"];
            delete dn.QueryString["mine"];

            if (dn.CurrentTopicId == -1) 
            {
                // Subscriptions
                streamTitle = (stream.Type ? 'Subscription ' + dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream : 'Subscriptions');
                dn.QueryString["subscriptions"] = "1";
                document.title = streamTitle + ' – ' + dn.constants.CommunityName;
            } 
            else if (dn.CurrentTopicId == -2) 
            {
                // My Discussions
                streamTitle = 'My ' + (stream.Type ? dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream : 'Discussions');
                dn.QueryString["mine"] = "1";
                document.title = streamTitle + ' – ' + dn.constants.CommunityName;
            }
            else
            {
                // All Topics
                streamTitle = (stream.Type 
                    ? dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream 
                    : 'All Messages');
                document.title = (stream.Type ? dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream + ' - ' : '') + dn.constants.CommunityName;
                $('#feedlink-main').attr('title', (stream.Type ? (dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream === dn.constants.DiscussionTypes[dn.CurrentTypeId].NamePluralized ? 'Latest ' + dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream : dn.constants.DiscussionTypes[dn.CurrentTypeId].NameInStream) : 'Latest Discussions') + ' on ' + dn.constants.CommunityName).attr('href', '/api/v1/messages?o=atom&s=0&nr=1');
            }

            if (embed)
            {
                streamTitle += " on " + dn.constants.CommunityName;
            }

            $('.dn-stream-title').html(streamTitle);

            history.replaceState(null, document.title, "/" + stream.Type + dn.QueryStringFromJson(dn.QueryString, '?'));
        }
        else
        {
            // Normal topic or user group selected
            dn.topic.Lookup({topicIdOrKey: dn.CurrentTopicId, showAjaxSpinner: false, 
                onSuccess: function(topic) {
                    streamTitle = '<span class="d-inline d-sm-none">' + topic.NameShort + '</span><span class="d-none d-sm-inline">' + topic.Name + '</span>' + (stream.Type ? ' ' + dn.constants.DiscussionTypes[dn.CurrentTypeId].NamePluralized.replace(topic.Name, '') : '') + (embed ? " on " + dn.constants.CommunityName : "");
                    $('.dn-stream-title').html(streamTitle);
                    document.title = topic.Name + (stream.Type ? ' ' + dn.constants.DiscussionTypes[dn.CurrentTypeId].NamePluralized : '') + ' – ' + dn.constants.CommunityName;
                    $('#feedlink-main').attr('title', 'Latest ' + topic.NameShort + ' ' + (stream.Type ? dn.constants.DiscussionTypes[dn.CurrentTypeId].NamePluralized : 'Discussions') + ' on ' + dn.constants.CommunityName).attr('href', '/api/v1/messages?o=atom&s=0&nr=1&to=' + dn.CurrentTopicId);
                    history.replaceState(null, document.title, (stream.Type ? '/' + stream.Type : '') + topic.LinkRelative + dn.QueryStringFromJson(dn.QueryString, '?'));
                }, 
                onError: function() {
                    console.error('Failed to find the topic or user group: ' + dn.CurrentTopicId);
                }
            });
        }

        if ($('#filter-select').width() > 220)
        {
            $('#filter-select').css('font-size', '1.1rem');
        }
        else
        {
            $('#filter-select').css('font-size', '');
        }

        // bonus points: if they have the compose form open, and if they haven't REALLY
        // started writing their message yet, go ahead and change the topics.
        var title = $('.dn-compose-form').first().find(".dn-compose-Title").val();
        var body = null; // TODO: Rewire this: dn.compose.GetData('dn-compose-form');

        if (!title && (!body || body === '<p>&nbsp;</p>'))
        {
            if (dn.compose.Selectize['dn-compose-Topics'] && dn.CurrentTopicId > 0)
            {
                // they are filtered down to a specific topic
                dn.compose.Selectize['dn-compose-Topics'].setValue(stream.Topics);
            }
            if (dn.compose.Selectize['dn-compose-Type'] && dn.CurrentTypeId)
            {
                // they are filtered down to a specific type
                dn.compose.Selectize['dn-compose-Type'].setValue(dn.CurrentTypeId);
            }
        }

        if (fetch)
        {
            $('.dn-filter-dropdown').scrollTop(0);
            stream.Vue.fetch();
        }

    }, 10, false); // wait 10 ms before executing, to see if we are processing multiple requests

    $(document).ready
    (
        function ($)
        {
            // Process any queued functions now that the namespace is ready.
            dn.ProcessQueuedFunctions('dn.stream');
        }
    );

}(window.dn.stream = window.dn.stream || {}, jQuery));